// extracted by mini-css-extract-plugin
export default {"date":"event-data-info_date__uYufO","duration":"event-data-info_duration__+qSmS"};